import axiosInstance from './axiosInstance';

const BASE = '/Corrohealth/api/reports/monthly';

function unwrap(res) {
  const data = res.data?.data ?? res.data ?? {};
  if (data && data.success === false) {
    throw new Error(data.error || data.message || 'Server error');
  }
  return data;
}

const monthlyReportsApi = {
  getLocations: async () => {
    const res = await axiosInstance.get(`${BASE}/locations`);
    const data = res.data?.data ?? res.data ?? [];
    return Array.isArray(data) ? data : [];
  },

  getVehicleReport: async (startDate, endDate, location) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate)   params.endDate   = endDate;
    if (location)  params.location  = location;
    const res = await axiosInstance.get(`${BASE}/vehicle`, { params });
    return unwrap(res);
  },

  getWorkspaceReport: async (startDate, endDate, location) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate)   params.endDate   = endDate;
    if (location)  params.location  = location;
    const res = await axiosInstance.get(`${BASE}/workspace`, { params });
    return unwrap(res);
  },

  getHelpdeskReport: async (startDate, endDate, location) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate)   params.endDate   = endDate;
    if (location)  params.location  = location;
    const res = await axiosInstance.get(`${BASE}/helpdesk`, { params });
    return unwrap(res);
  },

  getJobReport: async (startDate, endDate, location) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate)   params.endDate   = endDate;
    if (location)  params.location  = location;
    const res = await axiosInstance.get(`${BASE}/job`, { params });
    return unwrap(res);
  },

  getIdCardReport: async (startDate, endDate, location) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate)   params.endDate   = endDate;
    if (location)  params.location  = location;
    const res = await axiosInstance.get(`${BASE}/idcard`, { params });
    return unwrap(res);
  },
};

export default monthlyReportsApi;
